import { Pipe, PipeTransform } from '@angular/core';
import {
    BabylonButtonI,
    BabylonHeaderBookShowI,
    BabylonHeaderClearI,
    BabylonHeaderMenuCenterI,
    BabylonHeaderMenuLogoCenterI,
    BabylonHeaderMenuShowI,
    BabylonHeaderMobileI,
} from '@ctt-babylon/public-api';

@Pipe({
    name: 'btnBook',
    standalone: true,
    pure: true,
})
export class BtnBookPipe implements PipeTransform {
    transform(
        data:
            | BabylonHeaderBookShowI
            | BabylonHeaderClearI
            | BabylonHeaderMenuCenterI
            | BabylonHeaderMenuShowI
            | BabylonHeaderMenuLogoCenterI
            | BabylonHeaderMobileI
            | null
            | undefined,
        enabled: boolean
    ): BabylonButtonI | undefined {
        return enabled ? data?.btnBook : undefined;
    }
}
